import { Reveal, Overline } from "./Reveal";
import { TEAM } from "../../lib/content";
import { useLang } from "../../lib/i18n";

export const Team = () => {
  const { tr } = useLang();
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative bg-ad-surface py-24 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          {/* Sticky intro */}
          <div className="lg:col-span-4">
            <Reveal className="lg:sticky lg:top-28">
              <Overline>{tr("Le Persone", "The People")}</Overline>
              <h2 className="mt-6 font-serif-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white">
                {tr("Il Cuore del", "The Heart of")}{" "}
                <span className="italic text-gold">{tr("Nostro Atelier", "Our Atelier")}</span>
              </h2>
              <p className="mt-6 font-sans-ui font-light text-white/60 leading-relaxed max-w-sm">
                {tr(
                  "Un team unito dalla stessa passione: accompagnarti, con competenza e calore, verso il tuo giorno perfetto.",
                  "A team united by the same passion: guiding you, with expertise and warmth, towards your perfect day."
                )}
              </p>
              <div className="hairline w-24 mt-10" />
            </Reveal>
          </div>

          {/* Members list */}
          <div className="lg:col-span-7 lg:col-start-6">
            {TEAM.map((m, i) => (
              <Reveal
                key={m.name}
                delay={i * 0.1}
                data-testid={`team-member-${m.name.toLowerCase()}`}
                className="border-t border-white/12 py-10 md:py-12 group"
              >
                <div className="flex items-start gap-6 md:gap-10">
                  <span className="font-serif-display text-2xl md:text-3xl text-gold/60 leading-none pt-2 tabular-nums group-hover:text-gold transition-colors duration-500">
                    0{i + 1}
                  </span>
                  <div>
                    <h3 className="font-serif-display text-4xl md:text-5xl text-white font-light leading-none group-hover:text-gold transition-colors duration-500">
                      {m.name}
                    </h3>
                    <p className="mt-3 font-sans-ui text-[11px] uppercase tracking-[0.28em] text-gold">
                      {tr(m.role, m.roleEn)}
                    </p>
                    <p className="mt-5 font-sans-ui font-light text-white/60 leading-relaxed max-w-xl">
                      {tr(m.bio, m.bioEn)}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
            <div className="border-t border-white/12" />
          </div>
        </div>
      </div>
    </section>
  );
};
